import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cthcrk96df: FaireBrandEntity = {
  token: "b_cthcrk96df",
  type: "brand",
  name: "Bleu La La",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc05654a500242bd4dc28bdad724b26985c990dccac44511b0d55f4102684a2e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f6fb5042c8335304efd99be8b457793618e1f7be93d1c3fbfd027fdef907ea7e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fc05654a500242bd4dc28bdad724b26985c990dccac44511b0d55f4102684a2e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f6fb5042c8335304efd99be8b457793618e1f7be93d1c3fbfd027fdef907ea7e.jpeg",
  location: "Toms River, NJ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 53,
  isTopShop: true,
  isInsider: true,
  description:
    "At Bleu La La we are all about creating unique, high-quality baby gear that is mindfully curated and available at prices that are fair to all. We use cpsia compliant and eco-friendly materials and sustainable production methods to create products that are not only stylish, but also good for the planet.\n\nOur brand is more than just a baby company, it's a community of like-minded parents who share our values of individuality and sustainability. We believe that every baby is special, and they deserve special gear to match. \n\nThat's why we donate 10% of profits are donated to children's charities. Join us in our mission to provide a fair chance for all.\n\n♥ Esther & Co\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:34.123Z",
    importedBy: "entity-db-cli",
  },
};
